import CreateAnswer from "../../components/CreateAnswer";
function CreateAnswerPage() {
  return <CreateAnswer />;
}

export default CreateAnswerPage;
